import React from 'react';

export function ErrorPage() {
  return (
    <main className="error-page" data-testid="error-page">
      Error 404. Page was not found
    </main>
  );
}
